module.exports = __webpack_public_path__ + "static/img/icon_8.a043bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_8.png
// module id = gsNx
// module chunks = 0